/**
 * Sequential resolution of promises
 */
export default async function runInSequence(fns: Fn[]): Promise<Response[]> {
  const results = [];
  let response;

  for (const fn of fns) {
    try {
      response = await fn();
    } catch (error) {
      response = error;
    }

    results.push(response);
  }

  return results as [];
}
